import React, { useMemo } from 'react';
import { Medicine } from '../../interfaces/medicine';
import { Flex } from '../UI-CHAKRA/Flex';
import MedicineSearchItem from './MedicineSearchItem';
import SearchResultItem from './SearchResultItem';

interface MedicineListProps {
  medicines: Medicine[];
  onSelectMedicine(medicine: Medicine): void;
}

export default function MedicineList(props: MedicineListProps) {
  const { medicines, onSelectMedicine } = props;

  const list = useMemo(() => {
    if (!medicines || medicines.length === 0) return;

    return (
      medicines.length > 0 &&
      medicines.map((medicine) => {
        return (
          <SearchResultItem
            isPremiumPlacement={medicine.isPremiumPlacement}
            onClick={() => onSelectMedicine(medicine)}
            key={medicine.IdMedicamento}
          >
            <MedicineSearchItem medicine={medicine} />
          </SearchResultItem>
        );
      })
    );
  }, [medicines, onSelectMedicine]);

  return <Flex flexDir={'column'}>{list}</Flex>;
}
